export const PLAN_RESTRICTION_FORM_ID = '5fc61564-9a74-4d58-b012-7bffe4f48724'
export const FRAUD_INDICATORS_FORM_ID = '1bf99038-587d-4d52-8dbd-520bc533329d'
